webpackJsonp([20],{

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _NewFooterV = __webpack_require__(544);

var _NewFooterV2 = _interopRequireDefault(_NewFooterV);

var _NewMenu = __webpack_require__(551);

var _NewMenu2 = _interopRequireDefault(_NewMenu);

var _DemoForm = __webpack_require__(542);

var _DemoForm2 = _interopRequireDefault(_DemoForm);

var _FormHero = __webpack_require__(617);

var _FormHero2 = _interopRequireDefault(_FormHero);

var _TwoColsV = __webpack_require__(596);

var _TwoColsV2 = _interopRequireDefault(_TwoColsV);

var _IndicatorsGrid = __webpack_require__(706);

var _IndicatorsGrid2 = _interopRequireDefault(_IndicatorsGrid);

var _CallToActionSection = __webpack_require__(619);

var _CallToActionSection2 = _interopRequireDefault(_CallToActionSection);

__webpack_require__(708);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SalesForcev2 = function (_Component) {
    _inherits(SalesForcev2, _Component);

    function SalesForcev2() {
        _classCallCheck(this, SalesForcev2);

        return _possibleConstructorReturn(this, (SalesForcev2.__proto__ || Object.getPrototypeOf(SalesForcev2)).apply(this, arguments));
    }

    _createClass(SalesForcev2, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                this.props.headData && _react2.default.createElement(
                    _reactStatic.Head,
                    null,
                    _react2.default.createElement(
                        'title',
                        null,
                        this.props.headData.pageTitle
                    ),
                    _react2.default.createElement('meta', { property: 'og:title', content: this.props.headData.pageTitle }),
                    _react2.default.createElement('meta', { name: 'twitter:title', content: this.props.headData.pageTitle }),
                    _react2.default.createElement('meta', { name: 'description', content: this.props.headData.pageDescription }),
                    _react2.default.createElement('meta', { property: 'og:description', content: this.props.headData.pageDescription }),
                    _react2.default.createElement('meta', { name: 'twitter:description', content: this.props.headData.pageDescription }),
                    _react2.default.createElement('meta', { property: 'og:image', content: this.props.headData.ogImage }),
                    _react2.default.createElement('meta', { name: 'twitter:image', content: this.props.headData.ogImage }),
                    _react2.default.createElement('meta', { property: 'og:url', content: this.props.headData.ogUrl }),
                    _react2.default.createElement('link', { rel: 'canonical', href: this.props.headData.ogUrl }),
                    _react2.default.createElement(
                        'script',
                        { type: 'application/ld+json' },
                        '{\n                            "@context": "https://schema.org",\n                            "@type": "ImageObject",\n                            "contentUrl": "https://mercos.com/images/sistema-de-forca-de-vendas.png",\n                            "url": "https://mercos.com/images/sistema-de-forca-de-vendas.png",\n                            "name": "Sistema de For\xE7a de Vendas",\n                            "description": "A imagem mostra alguns dos indicadores do sistema de for\xE7a de vendas Mercos sendo eles Evolu\xE7\xE3o de Venda, Carteira de Clientes (que cont\xE9m um gr\xE1fico de pizza com Clientes Ativos, Inativos antigos e Recentes e Prospects), E-commerce B2B, valor vendido no m\xEAs, situa\xE7\xE3o do cliente nos \xFAltimos 6 meses, Pedidos e Atendimentos",\n                            "thumbnail": {\n                                "@type": "ImageObject",\n                                "contentUrl": "https://mercos.com/images/sistema-de-forca-de-vendas.png"\n                            },\n                            "width": 809,\n                            "height": 656,\n                            "uploadDate": "2025-08-22",\n                            "license": "https://mercos.com/",\n                            "author": {\n                                "@type": "Organization",\n                                "name": "Mercos",\n                                "url": "https://www.mercos.com"\n                            },\n                            "copyrightHolder": {\n                                "@type": "Organization",\n                                "name": "Mercos"\n                            }\n                        }'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'new-sales-force-v3' },
                    _react2.default.createElement(_NewMenu2.default, { transparentOnTop: true, pixelsToShowMenuWhite: 50, mutableMenu: true, hideOnScroll: true }),
                    _react2.default.createElement(_FormHero2.default, {
                        className: 'new-sales-hero',
                        titleId: 'sales-force-hero-title',
                        overtitle: 'For\xE7a de vendas',
                        title: _react2.default.createElement(
                            _react.Fragment,
                            null,
                            'Sistema de for\xE7a de vendas l\xEDder ',
                            _react2.default.createElement(
                                'span',
                                { className: 'mobile-slim' },
                                'para ind\xFAstrias, distribuidoras e representantes'
                            )
                        ),
                        description: 'Automatize sua opera\xE7\xE3o comercial de ponta a ponta com o sistema de for\xE7a de vendas Mercos: emita pedidos e melhore a gest\xE3o de clientes, produtos, equipe e dados, integrando tudo a qualquer ERP',
                        form: _react2.default.createElement(_DemoForm2.default, { showForm: true, inline: true, formHeroStyle: true, title: 'Fale com um especialista e veja o Mercos na pr\xE1tica', submitButtonText: 'Solicitar Demonstra\xE7\xE3o' })
                    }),
                    _react2.default.createElement(_TwoColsV2.default, {
                        overTitle: 'For\xE7a de vendas n\xB01 do mercado',
                        title: 'O sistema mais completo para suas vendas',
                        description: 'Da emiss\xE3o de pedidos \xE0 integra\xE7\xE3o com seu ERP: conte com IA, CRM, controle de estoque e dados em tempo real para uma gest\xE3o centralizada e sucesso nas vendas',
                        imageSrc: '/images/sistema-de-forca-de-vendas.png',
                        imageAlt: 'Sistema de For\xE7a de Vendas',

                        isImageFullWidth: true,

                        testimonial: {
                            text: "Evoluímos muito a qualidade dos pedidos, desde a emissão até a entrega. Além disso, integramos o Mercos ao nosso ERP e automatizamos nosso fluxo operacional",
                            personName: "Henrique Zompeiro",
                            companyName: "Gerente Financeiro na Corsa Bike",
                            personImage: "/images/site/depoimentos/henrique-zompeiro.png"
                        },
                        radialBg: 'purple'
                    }),
                    _react2.default.createElement(_TwoColsV2.default, {
                        overTitle: 'Automatize seus pedidos com IA',
                        title: 'Economize 90% do tempo gasto em pedidos',
                        description: 'Mais vendas, menos esfor\xE7os: com a IA do Mercos, voc\xEA emite pedidos em segundos a partir de arquivos recebidos pelo WhatsApp e confere sugest\xF5es autom\xE1ticas para ampliar seu mix de produtos',
                        imageSrc: '/images/site/landing-pages/forca-vendas/economize.png',
                        imageAlt: 'Imagem do sistema de pedidos com IA da Mercos, que oferece automa\xE7\xE3o da for\xE7a de vendas. \xC9 poss\xEDvel ver a tela em que os pedidos que chegam por WhatsApp, e-mail, planilhas, \xE1udios, texto ou PDF s\xE3o adicionados, permitindo a emiss\xE3o r\xE1pida de pedidos, economizando at\xE9 90% de tempo nessa tarefa. H\xE1 tamb\xE9m os bot\xF5es "Encontrar produtos", "Cancelar" e "Como funciona", que guiam o usu\xE1rio pela experi\xEAncia do recurso.',
                        isReverse: true,
                        testimonial: {
                            text: "Otimizamos bastante o tempo gasto com os muitos pedidos que chegavam pelo WhatsApp. É só copiar e colar a mensagem e, se necessário, ajustar algum item. É rápido, simples e muito eficiente.",
                            personName: "Eduardo Woiciechoski",
                            companyName: "WB Distribuidora"
                        },
                        radialBg: 'green'
                    }),
                    _react2.default.createElement(_TwoColsV2.default, {
                        overTitle: 'Aplicativo Mercos',
                        title: 'A equipe de vendas no controle das metas',
                        description: 'Tenha o poder nas m\xE3os com o aplicativo de for\xE7a de vendas Mercos: acesse pol\xEDticas comerciais, gerencie clientes, or\xE7amentos e representadas com facilidade e acompanhe suas metas de perto',
                        imageSrc: '/images/site/landing-pages/forca-vendas/equipe-de-vendas.png',
                        imageAlt: 'Imagem do app de for\xE7a de vendas Mercos mobile. O aplicativo est\xE1 aberto na tela de or\xE7amento, mostrando um cliente fict\xEDcio chamado "Cliente B2B". \xC9 poss\xEDvel adicionar produtos para emitir um pedido para ele, definir descontos e acr\xE9scimos e avaliar detalhes sobre o pedido. Ao lado, h\xE1 a mensagem "pedido emitido / conclu\xEDdo", mostrando o quanto \xE9 f\xE1cil realizar a emiss\xE3o de pedidos pelo sistema de for\xE7a de vendas Mercos.',
                        testimonial: {
                            text: 'Antes, tínhamos apenas um \'tirador de pedidos\'. Perdíamos muito tempo, o vendedor não tinha acesso a dados em tempo real e não conseguia vender offline. Hoje, é tudo muito rápido. Ganhamos tempo e reduzimos os erros dos processos manuais',
                            personName: "Raimylson Dias",
                            companyName: "Estratégico da Esquadromil",
                            personImage: "/images/site/depoimentos/raimylson-dias.png"
                        },
                        radialBg: 'purple'

                    }),
                    _react2.default.createElement(_TwoColsV2.default, {
                        overTitle: 'Integra\xE7\xE3o total',
                        title: 'Conectado com as principais ferramentas do mercado',
                        description: 'Integra\xE7\xE3o com softwares como ERPs, BIs, CRMs e outros, de forma est\xE1vel, com APIs abertas e suporte t\xE9cnico real, garantindo efici\xEAncia e seguran\xE7a sem complica\xE7\xF5es para a TI',
                        imageSrc: '/images/site/landing-pages/forca-vendas/conectado.png',
                        imageAlt: 'Imagem com um compilado de logos de empresas com as quais o Mercos se conecta, por meio de integra\xE7\xF5es realizadas com APIs abertas, seguras e sem complica\xE7\xF5es para TI. \xC9 poss\xEDvel ver exemplos de ERPs, BIs e CRMs, como Power BI, Tiny, Conta Azul, Sankhya, SAP, Zucchetti, Cigam, entre outros',
                        isReverse: true

                    }),
                    _react2.default.createElement(_IndicatorsGrid2.default, null),
                    _react2.default.createElement(_CallToActionSection2.default, null)
                ),
                _react2.default.createElement(_NewFooterV2.default, null)
            );
        }
    }]);

    return SalesForcev2;
}(_react.Component);

exports.default = (0, _reactStatic.withRouteData)(function (props) {
    return _react2.default.createElement(SalesForcev2, props);
});

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webpSrc = _ref.webpSrc,
        mobileSrc = _ref.mobileSrc,
        alt = _ref.alt,
        className = _ref.className,
        desktop = _ref.desktop,
        mobile = _ref.mobile,
        noWebp = _ref.noWebp,
        fetchPriority = _ref.fetchPriority,
        width = _ref.width,
        height = _ref.height,
        style = _ref.style,
        loading = _ref.loading,
        onLoad = _ref.onLoad,
        srcSet = _ref.srcSet,
        sizes = _ref.sizes,
        decoding = _ref.decoding,
        imgProps = _objectWithoutProperties(_ref, ['src', 'webpSrc', 'mobileSrc', 'alt', 'className', 'desktop', 'mobile', 'noWebp', 'fetchPriority', 'width', 'height', 'style', 'loading', 'onLoad', 'srcSet', 'sizes', 'decoding']);

    // Detect external URLs - if src starts with http:// or https://, it's external
    var isExternal = src && (src.startsWith('http://') || src.startsWith('https://'));
    // Skip WebP for external URLs or when noWebp prop is explicitly set
    var shouldSkipWebp = noWebp || isExternal;

    var extension = src.split('.').pop();
    var isSvg = extension.toLowerCase() === 'svg';
    var webpSource = webpSrc || src.replace('.' + extension, '.webp');
    var desktopClass = desktop ? 'desktop-only' : '';
    var mobileClass = mobile ? 'mobile-only' : '';
    var loadingValue = loading || (fetchPriority ? "eager" : "lazy");

    // Common img props to pass through
    var commonImgProps = _extends({
        className: className + ' ' + desktopClass + ' ' + mobileClass,
        src: '' + src,
        alt: '' + alt,
        loading: loadingValue,
        width: width,
        height: height,
        style: style,
        onLoad: onLoad,
        srcSet: srcSet,
        sizes: sizes,
        decoding: decoding,
        fetchpriority: fetchPriority }, imgProps);

    // For SVG files, just return a simple img tag without picture/source elements
    if (isSvg) {
        return _react2.default.createElement('img', commonImgProps);
    }

    return _react2.default.createElement(
        'picture',
        null,
        mobileSrc && _react2.default.createElement(
            _react.Fragment,
            null,
            !shouldSkipWebp && _react2.default.createElement('source', {
                srcSet: webpSource + ', ' + mobileSrc.replace('.' + extension, '.webp') + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/webp'
            }),
            _react2.default.createElement('source', {
                srcSet: src + ', ' + mobileSrc + ' 2x',
                media: '(max-width: 990px)',
                type: 'image/' + extension
            })
        ),
        !shouldSkipWebp && _react2.default.createElement('source', { srcSet: '' + webpSource, type: 'image/webp' }),
        _react2.default.createElement('img', commonImgProps)
    );
};

exports.default = Picture;

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	var gad_campaignid = _jsCookie2.default.get('madscampaignid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		params += gad_campaignid ? '&gad_campaignid=' + gad_campaignid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
    var ariaLabel = _ref.ariaLabel,
        children = _ref.children,
        className = _ref.className,
        disabled = _ref.disabled,
        model = _ref.model,
        onClick = _ref.onClick,
        purple = _ref.purple,
        radius = _ref.radius,
        size = _ref.size,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'button' : _ref$type,
        shake = _ref.shake;
    return _react2.default.createElement(
        'button',
        { className: (0, _classnames2.default)('button', model, size, radius, className, purple && 'purple', shake && 'shake'),
            type: type,
            onClick: onClick,
            'aria-label': ariaLabel,
            disabled: disabled },
        children
    );
};

Button.propTypes = {
    className: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    children: _propTypes2.default.any,
    model: _propTypes2.default.oneOf(['alert', 'outline', 'no-borders', 'secondary', 'success', 'warning']),
    size: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['button', 'submit']),
    radius: _propTypes2.default.oneOf(['right-bottom-only', 'half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded', 'italic'])
};

exports.default = Button;

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

var _CloseButton = __webpack_require__(538);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

__webpack_require__(540);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCloseButton = function getCloseButton(callbackCloseModal, hasImage) {
  return _react2.default.createElement(
    'div',
    { className: 'site-close-modal-button' },
    hasImage,
    _react2.default.createElement(_CloseButton2.default, { outlineOnly: !hasImage, onClickButton: callbackCloseModal })
  );
};

var Modal = function Modal(_ref) {
  var className = _ref.className,
      overlayColor = _ref.overlayColor,
      imageURL = _ref.imageURL,
      callbackCloseModal = _ref.callbackCloseModal,
      children = _ref.children,
      video = _ref.video,
      overlayStyles = _ref.overlayStyles,
      hideCloseButton = _ref.hideCloseButton;

  var hasImage = Boolean(imageURL);

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('site-modal-container', className) },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)({ 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage }, video ? 'video' : '', overlayStyles ? overlayStyles : '')
      },
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('site-modal-content text-left', video ? 'video' : '') },
        children
      ),
      hasImage && _react2.default.createElement('div', {
        className: 'site-modal-image',
        style: { background: 'url(\'' + imageURL + '\') no-repeat center' }
      }),
      !hideCloseButton && getCloseButton(callbackCloseModal, hasImage)
    ),
    _react2.default.createElement('div', {
      className: (0, _classnames2.default)('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : ''),
      onClick: callbackCloseModal
    })
  );
};

exports.default = Modal;

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var telephoneMask = exports.telephoneMask = function telephoneMask(value) {
    var cleanTelephone = value ? value.replace(/\D/g, "") : '';
    var numberLength = cleanTelephone.length;

    if (numberLength > 10) {
        cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
    } else if (numberLength > 6 && numberLength < 11) {
        cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
    }

    if (numberLength > 2) {
        cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
    }

    if (numberLength > 0) {
        cleanTelephone = '(' + cleanTelephone.slice(0);
    }

    return cleanTelephone;
};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(539);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton(_ref) {
    var onClickButton = _ref.onClickButton,
        _ref$outlineOnly = _ref.outlineOnly,
        outlineOnly = _ref$outlineOnly === undefined ? false : _ref$outlineOnly;
    return _react2.default.createElement('button', { className: (0, _classnames2.default)({
            'site-close-button-outline': outlineOnly,
            'site-close-button': !outlineOnly
        }), onClick: onClickButton });
};

exports.default = CloseButton;

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        inputPlaceholder = _ref.inputPlaceholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement(
        'div',
        { className: 'floating-label-wrapper' },
        _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
            'aria-label': ariaLabel,
            autoFocus: autoFocus,
            id: id,
            maxLength: maxLength,
            onChange: onChange,
            placeholder: inputPlaceholder,
            type: type,
            value: value,
            name: name || id,
            required: true
        }),
        _react2.default.createElement(
            'span',
            { className: 'floating-label' },
            placeholder
        )
    );
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    inputPlaceholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(174);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _Button = __webpack_require__(533);

var _Button2 = _interopRequireDefault(_Button);

var _Modal = __webpack_require__(535);

var _Modal2 = _interopRequireDefault(_Modal);

var _Input = __webpack_require__(546);

var _Input2 = _interopRequireDefault(_Input);

var _RDGateway = __webpack_require__(175);

var _RDGateway2 = _interopRequireDefault(_RDGateway);

var _masks = __webpack_require__(537);

var _Utm = __webpack_require__(532);

var _ModalTestimonials = __webpack_require__(552);

var _ModalTestimonials2 = _interopRequireDefault(_ModalTestimonials);

var _InputFloatingLabel = __webpack_require__(541);

var _InputFloatingLabel2 = _interopRequireDefault(_InputFloatingLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELDS = ['name', 'email', 'telephone', 'activity', 'users'];

var ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
};

var USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
};

var DemoForm = function (_Component) {
    _inherits(DemoForm, _Component);

    function DemoForm(props) {
        _classCallCheck(this, DemoForm);

        var _this = _possibleConstructorReturn(this, (DemoForm.__proto__ || Object.getPrototypeOf(DemoForm)).call(this, props));

        _this.handleActivityDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleUsersDropdownClick = function (e) {
            var dropdown = e.currentTarget.nextElementSibling;
            var button = e.currentTarget;

            dropdown.classList.toggle('show');
            button.classList.toggle('expanded');
        };

        _this.handleActivityOptionClick = function (activity) {
            var button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
            var dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = activity;

            _this.handlerEnterpriseActivity(activity);
        };

        _this.handleUsersOptionClick = function (users) {
            var wrapper = document.activeElement.closest('.activity-wrapper');
            var button = wrapper.querySelector('.activity-dropdown-button');
            var dropdown = wrapper.querySelector('.activity-dropdown');

            dropdown.classList.remove('show');
            button.classList.remove('expanded');
            button.classList.add('option-selected');
            button.textContent = users;

            _this.handlerUsers(users);
        };

        _this.rdGateway = new _RDGateway2.default();
        _this.state = _this.getInitialState(props);

        globalThis.optimizeOpenPopup = function () {
            _this.setState({ showDemoModal: true });
        };
        return _this;
    }

    _createClass(DemoForm, [{
        key: 'getInitialState',
        value: function getInitialState(props) {
            var initialObject = {
                showDemoModal: false,
                company: '',
                name: '',
                email: '',
                telephone: '',
                activity: '',
                users: '',
                typingTimeout: 0,
                partnerId: props.partnerId,
                rdWhatsappLauncherReady: false
            };
            FIELDS.forEach(function (campo) {
                initialObject[campo + 'Error'] = false;
                initialObject[campo + 'Typing'] = false;
            });
            return initialObject;
        }
    }, {
        key: 'setDataByCookie',
        value: function setDataByCookie() {
            this.setState({
                partnerId: _jsCookie2.default.get('leaderPartnerId') || this.state.partnerId || ''
            });
        }
    }, {
        key: 'openDemoModal',
        value: function openDemoModal(e) {
            e.preventDefault();

            this.setState({
                showDemoModal: true
            });
        }
    }, {
        key: 'closeDemoModal',
        value: function closeDemoModal() {
            this.setState({
                showDemoModal: false
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var _this2 = this,
                _setState;

            var name = e.target.id;
            var value = e.target.value;
            var company = this.state.name + ' - ' + this.state.email;

            if (name === 'telephone') {
                value = this.telephoneMask(value);
            } else if (name === 'name') {
                company = value + ' - ' + this.state.email;
            } else if (name === 'email') {
                value = value.trim();
                company = this.state.name + ' - ' + value;
            }

            if (this.state.typingTimeout) {
                clearTimeout(this.state.typingTimeout);
            }

            this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'company', company), _defineProperty(_setState, name + 'Error', false), _defineProperty(_setState, name + 'Typing', true), _defineProperty(_setState, 'typingTimeout', setTimeout(function () {
                if (name === 'email' && _this2.validateEmail(_this2.state.email)) {}
            }, 3000)), _setState));
        }
    }, {
        key: 'handlerEnterpriseActivity',
        value: function handlerEnterpriseActivity(tipo) {
            this.setState({ 'activity': tipo });
        }
    }, {
        key: 'getSelectedActivity',
        value: function getSelectedActivity(selected) {
            return this.state.activity === selected ? 'active' : '';
        }
    }, {
        key: 'handlerUsers',
        value: function handlerUsers(tipo) {
            this.setState({ 'users': tipo });
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers(selected) {
            return this.state.users === selected ? 'active' : '';
        }
    }, {
        key: 'validation',
        value: function validation() {
            var _this3 = this;

            var newState = {};
            var fieldsToValidate = FIELDS;

            var regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/;
            fieldsToValidate.forEach(function (campo) {
                newState[campo + 'Error'] = !_this3.state[campo];
                switch (campo) {
                    case 'email':
                        {
                            newState[campo + 'Error'] = !_this3.validateEmail(_this3.state[campo]);
                            break;
                        }
                    case 'telephone':
                        {
                            newState[campo + 'Error'] = !regexTelephone.test(_this3.state[campo]);
                            break;
                        }
                }
            });
            this.setState(newState);
            var lista = Object.values(newState);
            return lista.every(function (value) {
                return !value;
            });
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            if (!email) return false;
            var trimmedEmail = email.trim();
            var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regexEmail.test(trimmedEmail.toLowerCase());
        }
    }, {
        key: 'submitForm',
        value: function submitForm(e) {
            e.preventDefault();
            if (this.validation()) {
                var data = {
                    conversion_identifier: 'solicite-uma-demonstracao-do-meus-pedidos',
                    'cf_tipo_de_conversao': 'Solicitou demonstração',
                    company_name: this.state.company,
                    name: this.state.name,
                    email: this.state.email,
                    personal_phone: this.state.telephone,
                    'cf_atividade_da_empresa': this.state.activity,
                    event_action: 'solicitou_demo',
                    event_label: 'forca_de_vendas'
                };

                data['cf_numero_de_vendedores'] = this.state.users;

                if (this.state.partnerId) {
                    data.conversion_identifier = 'canais-lp';
                    data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId;
                }

                var redirectLink = 'https://mercos.com/tp/solicitou-demo-fv/';
                if (this.state.activity === ACTIVITY.outra) redirectLink = 'https://materiais.mercos.com/tp-smb-solicitou-demo';else if (this.state.activity === ACTIVITY.rep) redirectLink = 'https://materiais.mercos.com/tp-reps-solicitou-demo';

                this.rdGateway.sendToRDStation(data, redirectLink);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDataByCookie();
            if (this.props.replaceTrialWithWhatsapp) {
                this.watchRDWhatsappLauncher();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopRDWhatsappPoll();
            if (this.rdWhatsappFallbackTimer) {
                clearTimeout(this.rdWhatsappFallbackTimer);
            }
        }
    }, {
        key: 'isRDWhatsappLauncherReady',
        value: function isRDWhatsappLauncherReady() {
            if (typeof document === 'undefined') return false;
            return Boolean(document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button'));
        }
    }, {
        key: 'stopRDWhatsappPoll',
        value: function stopRDWhatsappPoll() {
            if (this.rdWhatsappPollTimer) {
                clearInterval(this.rdWhatsappPollTimer);
                this.rdWhatsappPollTimer = null;
            }
        }
    }, {
        key: 'watchRDWhatsappLauncher',
        value: function watchRDWhatsappLauncher() {
            var _this4 = this;

            if (this.isRDWhatsappLauncherReady()) {
                this.setState({ rdWhatsappLauncherReady: true });
                return;
            }

            if (typeof document === 'undefined') return;

            this.rdWhatsappPollTimer = setInterval(function () {
                if (!_this4.isRDWhatsappLauncherReady()) return;
                _this4.setState({ rdWhatsappLauncherReady: true });
                _this4.stopRDWhatsappPoll();
            }, 300);

            this.rdWhatsappFallbackTimer = setTimeout(function () {
                _this4.stopRDWhatsappPoll();
            }, 7000);
        }
    }, {
        key: 'openRDWhatsappLauncher',
        value: function openRDWhatsappLauncher(e) {
            e.preventDefault();

            if (typeof window !== 'undefined' && typeof window.__mercosOpenRDWhatsappLauncher === 'function') {
                if (window.__mercosOpenRDWhatsappLauncher()) return;
            }

            var launcher = typeof document !== 'undefined' ? document.querySelector('.bricks--floating--button.rdstation-popup-js-floating-button') : null;

            if (launcher) {
                launcher.click();
                return;
            }

            (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
        }
    }, {
        key: 'getDemoModal',
        value: function getDemoModal() {
            var _this5 = this;

            if (this.props.minimalStyle) {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: this.props.formHeroStyle ? 'form-hero-demo-modal' : undefined },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal modal-context' },
                        this.getInlineForm()
                    )
                );
            } else if (this.props.modalSmall) {
                return this.getDemoModalSmall();
            } else {
                return _react2.default.createElement(
                    _Modal2.default,
                    { callbackCloseModal: function callbackCloseModal() {
                            return _this5.closeDemoModal();
                        }, className: 'site-simple-modal-testimonials' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header-logo' },
                        _react2.default.createElement('div', { className: 'logo-mercos-new-home' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        _react2.default.createElement(
                            'h4',
                            null,
                            'Solicite uma demonstra\xE7\xE3o'
                        ),
                        this.getForm()
                    ),
                    _react2.default.createElement(_ModalTestimonials2.default, null)
                );
            }
        }
    }, {
        key: 'getDemoModalSmall',
        value: function getDemoModalSmall() {
            var _this6 = this;

            return _react2.default.createElement(
                _Modal2.default,
                { callbackCloseModal: function callbackCloseModal() {
                        return _this6.closeDemoModal();
                    } },
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container-form-modal' },
                        this.getFormFloatingLabel()
                    )
                )
            );
        }
    }, {
        key: 'telephoneMask',
        value: function telephoneMask(value) {
            var cleanTelephone = value ? value.replace(/\D/g, '') : '';
            var numberLength = cleanTelephone.length;

            if (numberLength > 10) {
                cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7);
            } else if (numberLength > 6 && numberLength < 11) {
                cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6);
            }

            if (numberLength > 2) {
                cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2);
            }

            if (numberLength > 0) {
                cleanTelephone = '(' + cleanTelephone.slice(0);
            }

            return cleanTelephone;
        }
    }, {
        key: 'getForm',
        value: function getForm() {
            var _this7 = this;

            return _react2.default.createElement(
                'form',
                { action: '.', method: 'POST', className: 'form-rounded-inputs', onSubmit: function onSubmit(e) {
                        return _this7.submitForm(e);
                    } },
                _react2.default.createElement('input', { type: 'hidden', name: 'company', value: this.state.company }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'name' },
                    'Nome'
                ),
                _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.nameError, autoFocus: true }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'email' },
                    'E-mail'
                ),
                _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.emailError }),
                _react2.default.createElement(
                    'label',
                    { htmlFor: 'telephone' },
                    'Telefone'
                ),
                _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                        return _this7.handleChange(e);
                    }, error: this.state.telephoneError, maxLength: '15' }),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 a atividade da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.industria);
                            } },
                        'Ind\xFAstria'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.distribuicao);
                            } },
                        'Distribui\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.rep);
                            } },
                        'Representante comercial'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                return _this7.handlerEnterpriseActivity(ACTIVITY.outra);
                            } },
                        'Outra'
                    ),
                    this.state.activityError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'label',
                    null,
                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'group-buttons' },
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.um);
                            } },
                        '1'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinco);
                            } },
                        '2-5'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.vinte);
                            } },
                        '6-20'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquenta);
                            } },
                        '21-50'
                    ),
                    _react2.default.createElement(
                        _Button2.default,
                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                return _this7.handlerUsers(USERS.cinquentaum);
                            } },
                        '51 ou mais'
                    ),
                    this.state.usersError ? _react2.default.createElement(
                        'div',
                        { style: { color: 'red' } },
                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'submit-demo-modal' },
                    _react2.default.createElement(
                        _Button2.default,
                        { type: 'submit', radius: this.props.contaAzul ? 'all-rounded' : 'half-rounded', className: this.props.contaAzul && 'conta-azul' },
                        this.props.children || 'SOLICITAR'
                    )
                )
            );
        }
    }, {
        key: 'getFormFloatingLabel',
        value: function getFormFloatingLabel() {
            var _this8 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form new-form-floating-inputs' },
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-title' },
                        'Solicite uma demonstra\xE7\xE3o'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'new-form-subtitle' },
                        'Um de nossos consultores entrar\xE1 em contato.'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this8.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this8.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this8.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'wrapper-input-vendedores' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'label' },
                                    'Qual \xE9 o n\xFAmero de vendedores da sua empresa?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'group-buttons' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.um);
                                            } },
                                        '1'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinco);
                                            } },
                                        '2-5'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.vinte);
                                            } },
                                        '6-20'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquenta);
                                            } },
                                        '21-50'
                                    ),
                                    _react2.default.createElement(
                                        _Button2.default,
                                        { model: 'outline', className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                                return _this8.handlerUsers(USERS.cinquentaum);
                                            } },
                                        '51 ou mais'
                                    ),
                                    this.state.usersError ? _react2.default.createElement(
                                        'div',
                                        { style: { color: 'red' } },
                                        'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                                    ) : null
                                )
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getNewForm',
        value: function getNewForm() {
            var _this9 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    this.props.title === false ? null : _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ),
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this9.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_Input2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.nameError, placeholder: 'Nome' }),
                        _react2.default.createElement(_Input2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.emailError, placeholder: 'E-mail profissional' }),
                        _react2.default.createElement(_Input2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this9.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: 'Telefone' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this9.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Qual \xE9 a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                'solicitar demonstra\xE7\xE3o'
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'getInlineForm',
        value: function getInlineForm() {
            var _this10 = this;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-container' },
                    !this.props.hideTitle && this.props.title === false ? null : !this.props.hideTitle ? _react2.default.createElement(
                        'div',
                        { className: 'form-title' },
                        this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'
                    ) : null,
                    _react2.default.createElement(
                        'form',
                        { action: '.', method: 'POST', className: 'new-form', onSubmit: function onSubmit(e) {
                                return _this10.submitForm(e);
                            } },
                        _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'company', value: this.state.company }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'name', value: this.state.name, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.nameError, placeholder: this.props.formHeroStyle ? 'Nome completo' : 'Nome', inputPlaceholder: this.props.formHeroStyle ? 'Seu nome completo' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'email', value: this.state.email, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.emailError, placeholder: this.props.formHeroStyle ? 'E-mail profissional' : 'Seu e-mail', inputPlaceholder: this.props.formHeroStyle ? 'seu@empresa.com.br' : undefined }),
                        _react2.default.createElement(_InputFloatingLabel2.default, { id: 'telephone', value: this.state.telephone, onChange: function onChange(e) {
                                return _this10.handleChange(e);
                            }, error: this.state.telephoneError, maxLength: '15', placeholder: this.props.formHeroStyle ? 'Telefone / WhatsApp' : 'Telefone', inputPlaceholder: this.props.formHeroStyle ? '(00) 00000-0000' : undefined }),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleActivityDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.industria), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.industria);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-industrias.svg' }),
                                    'Ind\xFAstrias'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.distribuicao), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.distribuicao);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-distribuidoras.svg' }),
                                    'Distribuidoras'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.rep), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.rep);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-representates.svg' }),
                                    'Representantes'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedActivity(ACTIVITY.outra), onClick: function onClick() {
                                            return _this10.handleActivityOptionClick(ACTIVITY.outra);
                                        } },
                                    _react2.default.createElement(_Picture2.default, { src: '/images/icon-outros.svg' }),
                                    'Outra'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                this.props.formHeroStyle ? 'Atividade da sua empresa' : 'Qual é a atividade da sua empresa?'
                            ),
                            this.state.activityError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'activity-wrapper' },
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown-button', onClick: this.handleUsersDropdownClick },
                                'Selecione uma op\xE7\xE3o'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'activity-dropdown' },
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.um), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.um);
                                        } },
                                    '1'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinco), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinco);
                                        } },
                                    '2-5'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.vinte), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.vinte);
                                        } },
                                    '6-20'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquenta), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquenta);
                                        } },
                                    '21-50'
                                ),
                                _react2.default.createElement(
                                    _Button2.default,
                                    { className: this.getSelectedUsers(USERS.cinquentaum), onClick: function onClick() {
                                            return _this10.handleUsersOptionClick(USERS.cinquentaum);
                                        } },
                                    '51 ou mais'
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'floating-label' },
                                'Quantidade de vendedores da sua empresa'
                            ),
                            this.state.usersError ? _react2.default.createElement(
                                'div',
                                { style: { color: 'red' } },
                                'Oops! Voc\xEA esqueceu de escolher uma op\xE7\xE3o.'
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'submit-demo-modal' },
                            _react2.default.createElement(
                                _Button2.default,
                                { type: 'submit', className: 'new-submit new-button' },
                                this.props.submitButtonText || 'solicitar demonstração'
                            )
                        ),
                        this.props.formHeroStyle && _react2.default.createElement(
                            'div',
                            { className: 'form-hero-footer' },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Especialista dedicado'
                            ),
                            _react2.default.createElement('span', { className: 'form-hero-footer__dot', 'aria-hidden': 'true' }),
                            _react2.default.createElement(
                                'span',
                                null,
                                'Demonstra\xE7\xE3o personalizada'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'trial-link-wrapper' },
                            _react2.default.createElement(
                                'span',
                                { className: 'trial-link-text' },
                                'ou '
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://app.mercos.com/cadastro/',
                                    className: 'trial-link',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    }
                                },
                                'Fa\xE7a um teste gr\xE1tis \u203A'
                            )
                        ),
                        !this.props.showTrialLink && _react2.default.createElement(
                            'div',
                            { className: 'inline-trial-link modal-hide' },
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: function onClick() {
                                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                    },
                                    title: 'Fa\xE7a um teste gr\xE1tis'
                                },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'ou-text' },
                                    'ou'
                                ),
                                ' fa\xE7a um teste gr\xE1tis \u203A'
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'inline-trial-info' },
                                'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a ao terminar o per\xEDodo gr\xE1tis'
                            )
                        ),
                        this.props.showTrialLink && _react2.default.createElement(
                            'p',
                            { className: 'inline-form-trial-info' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                        )
                    )
                )
            );
        }
    }, {
        key: 'getCTA',
        value: function getCTA() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'cta-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'font-light font-12' },
                        'explore todos os recursos ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'n\xE3o precisa de cart\xE3o de cr\xE9dito ',
                        _react2.default.createElement(
                            'span',
                            { className: 'cta-text-separator' },
                            '| '
                        ),
                        'simples de usar'
                    )
                )
            );
        }
    }, {
        key: 'getModalButton',
        value: function getModalButton() {
            var _this11 = this;

            return _react2.default.createElement(
                'button',
                {
                    href: '.',
                    className: this.props.buttonShadow ? 'btn-white-shadow btn-modal ' : 'new-button button-secondary btn-modal ' + (this.props.darkBg ? 'button-secondary' : 'button-secondary-black') + ' button-cta',
                    onClick: function onClick(e) {
                        return _this11.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                this.props.fixedBottomBar ? 'pedir demonstração' : this.props.modalButtonText || 'peça uma demonstração'
            );
        }
    }, {
        key: 'getModalLink',
        value: function getModalLink() {
            var _this12 = this;

            return _react2.default.createElement(
                'div',
                { className: 'or-demo-wrapper' },
                this.props.showOr && _react2.default.createElement(
                    'span',
                    { style: { textDecoration: 'none' } },
                    ' ou '
                ),
                _react2.default.createElement(
                    'a',
                    {
                        href: '.',
                        className: 'button-txt btn-modal ' + (this.props.darkBg ? 'button-txt-white' : ''),
                        onClick: function onClick(e) {
                            return _this12.openDemoModal(e);
                        },
                        title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                    },
                    this.props.modalButtonText || 'peça uma demonstração ›'
                )
            );
        }
    }, {
        key: 'getTrialButton',
        value: function getTrialButton() {
            return _react2.default.createElement(
                'button',
                {
                    className: this.props.buttonShadow ? 'btn-green-shadow btn-trial' : 'new-button button-primary btn-trial button-cta button-trial ' + (this.props.darkBg ? 'dark-bg' : ''),
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    href: '#',
                    title: 'Cadastre-se no Mercos!'
                },
                this.props.trialAndDemo ? this.props.trialAndDemo : 'teste grátis'
            );
        }
    }, {
        key: 'getTrialAndDemo',
        value: function getTrialAndDemo() {
            var _this13 = this;

            if (this.props.minimalStyle) {
                var demoButtonClass = this.props.invertButtons ? 'button-primary' : 'button-secondary';
                var trialButtonClass = this.props.invertButtons ? 'button-secondary' : 'button-primary';

                return _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo mobile-only' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + demoButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick(e) {
                                return _this13.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'peça uma demonstração'
                    ),
                    !this.props.hideTrialButton && _react2.default.createElement(
                        'button',
                        {
                            className: 'new-button ' + trialButtonClass + ' ' + (this.props.darkBg ? 'dark-bg' : ''),
                            onClick: function onClick() {
                                return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                            },
                            href: '#',
                            title: 'Cadastre-se no Mercos!'
                        },
                        this.props.trialAndDemo || 'Faça um teste grátis'
                    ),
                    this.props.invertButtons && _react2.default.createElement(
                        'p',
                        { className: 'trial-info-text' },
                        'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a autom\xE1tica'
                    )
                );
            }

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'wrapper-trial-and-demo ' + (this.props.reverseButtons ? 'reverse-buttons' : '') },
                    !this.props.hideTrialButton && this.getTrialButton(),
                    this.props.modalLink ? this.getModalLink() : this.getModalButton()
                ),
                this.props.ctaText ? this.getCTA() : ''
            );
        }
    }, {
        key: 'getNewFormButtons',
        value: function getNewFormButtons() {
            var _this14 = this;

            var _props = this.props,
                buttonVariant = _props.buttonVariant,
                textAlign = _props.textAlign,
                ctaButtonText = _props.ctaButtonText,
                demoButtonText = _props.demoButtonText,
                bottomText = _props.bottomText;


            var isWhiteVariant = buttonVariant === 'white' || buttonVariant === 'inverted-white';
            var isInverted = buttonVariant === 'inverted' || buttonVariant === 'inverted-white';

            // Determine outline color (white or green)
            var outlineClass = isWhiteVariant ? 'new-form-btn-bordered-white' : 'new-form-btn-bordered-green';

            // Default: Faça=solid, Peça=outline
            // Inverted: Peça=solid, Faça=outline
            var trialButtonClass = isInverted ? 'new-form-btn ' + outlineClass : 'new-form-btn new-form-btn-solid-green';
            var demoButtonClass = isInverted ? 'new-form-btn new-form-btn-solid-green' : 'new-form-btn ' + outlineClass;

            var trialButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass,
                    onClick: function onClick() {
                        return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                    },
                    title: 'Cadastre-se no Mercos!'
                },
                ctaButtonText || 'Faça um teste grátis'
            );

            var whatsappButton = _react2.default.createElement(
                'button',
                {
                    className: trialButtonClass + ' new-form-whatsapp-btn',
                    onClick: function onClick(e) {
                        return _this14.openRDWhatsappLauncher(e);
                    },
                    title: 'Fale conosco no WhatsApp'
                },
                _react2.default.createElement(
                    'span',
                    { className: 'new-form-whatsapp-icon', 'aria-hidden': 'true' },
                    _react2.default.createElement(_Picture2.default, { src: '/images/site/whatsapp.png', alt: '' })
                ),
                this.props.whatsappButtonText || 'Fale conosco no WhatsApp'
            );

            var demoButton = _react2.default.createElement(
                'button',
                {
                    className: demoButtonClass,
                    onClick: function onClick(e) {
                        return _this14.openDemoModal(e);
                    },
                    title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                },
                demoButtonText || 'Peça uma demonstração'
            );

            var primaryButton = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? whatsappButton : trialButton;
            var currentBottomText = this.props.replaceTrialWithWhatsapp && this.state.rdWhatsappLauncherReady ? this.props.whatsappBottomText : bottomText;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-buttons-wrapper text-align-' + textAlign },
                    _react2.default.createElement(
                        'div',
                        { className: 'new-form-buttons-container' },
                        isInverted ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            demoButton,
                            primaryButton
                        ) : _react2.default.createElement(
                            _react.Fragment,
                            null,
                            primaryButton,
                            demoButton
                        )
                    ),
                    currentBottomText && _react2.default.createElement(
                        'p',
                        { className: 'new-form-bottom-text' },
                        currentBottomText.includes('|') ? _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                'span',
                                { className: 'desktop-text' },
                                currentBottomText
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'mobile-text' },
                                currentBottomText.split('|').map(function (part, index) {
                                    return _react2.default.createElement(
                                        _react.Fragment,
                                        { key: index },
                                        part.trim(),
                                        index < currentBottomText.split('|').length - 1 && _react2.default.createElement('br', null)
                                    );
                                })
                            )
                        ) : currentBottomText
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this15 = this;

            // Only show buttons WITH form when minimalStyle + showForm + modalButtonText (final CTA case)
            // Otherwise follow normal logic (buttons only when !showForm)
            var shouldShowButtons = this.props.minimalStyle && this.props.showForm && this.props.modalButtonText ? true : !this.props.showForm;

            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'new-form-wrapper ' + (this.props.inline || this.props.minimalStyle ? 'new-form-wrapper-b2b' : '') + ' ' + (this.props.ctaText ? 'same-width-buttons' : '') + ' ' + (this.props.darkBg ? 'dark-bg' : '') + ' ' + (this.props.fixedBottomBar ? 'demo-fixed-bottom' : '') + ' ' + (this.props.inlineBtns ? 'inline' : '') + ' ' + (this.props.newForm ? 'new-form-variant' : '') + ' ' + (this.props.buttonVariant === 'white' || this.props.buttonVariant === 'inverted-white' ? 'variant-white' : '') + ' ' + (this.props.className ? this.props.className : '') },
                    shouldShowButtons && this.props.newForm ? this.getNewFormButtons() : shouldShowButtons && this.props.trialButtonOnly ? _react2.default.createElement(
                        'button',
                        {
                            className: 'btn-green-shadow btn-modal',
                            onClick: function onClick(e) {
                                return _this15.openDemoModal(e);
                            },
                            title: 'Pe\xE7a uma demonstra\xE7\xE3o aos nossos especialistas.'
                        },
                        this.props.modalButtonText || 'quero contratar'
                    ) : shouldShowButtons ? this.getTrialAndDemo() : null,
                    this.props.showForm ? _react2.default.createElement(
                        'div',
                        { className: 'show-full-form' },
                        this.props.inline || this.props.minimalStyle ? this.getInlineForm() : this.getForm()
                    ) : '',
                    this.state.showDemoModal && this.getDemoModal()
                )
            );
        }
    }]);

    return DemoForm;
}(_react.Component);

DemoForm.propTypes = {
    b2b: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    color: _propTypes2.default.string,
    contaAzul: _propTypes2.default.bool,
    partnerId: _propTypes2.default.string,
    modalSmall: _propTypes2.default.bool,
    trialButtonOnly: _propTypes2.default.bool,
    inline: _propTypes2.default.bool,
    newForm: _propTypes2.default.bool,
    buttonVariant: _propTypes2.default.oneOf(['default', 'inverted', 'white', 'inverted-white']),
    textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
    ctaButtonText: _propTypes2.default.string,
    demoButtonText: _propTypes2.default.string,
    bottomText: _propTypes2.default.string,
    minimalStyle: _propTypes2.default.bool,
    showTrialLink: _propTypes2.default.bool,
    invertButtons: _propTypes2.default.bool,
    hideTitle: _propTypes2.default.bool,
    formHeroStyle: _propTypes2.default.bool,
    replaceTrialWithWhatsapp: _propTypes2.default.bool,
    whatsappButtonText: _propTypes2.default.string,
    whatsappBottomText: _propTypes2.default.string
};
DemoForm.defaultProps = {
    b2b: false,
    contaAzul: false,
    trialButtonOnly: false,
    inline: false,
    newForm: true,
    buttonVariant: 'default',
    textAlign: 'center',
    ctaButtonText: 'Faça um teste grátis',
    demoButtonText: 'Peça uma demonstração',
    bottomText: 'Teste grátis por 7 dias | Sem cobrança automática',
    minimalStyle: false,
    showTrialLink: false,
    invertButtons: false,
    hideTitle: false,
    formHeroStyle: false,
    replaceTrialWithWhatsapp: false,
    whatsappButtonText: 'Fale conosco no WhatsApp',
    whatsappBottomText: ''
};
exports.default = DemoForm;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(545);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var accessLinks = [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }];

    var footerRows = [[{
        title: 'Soluções',
        links: [{ name: 'Força de vendas', url: '/forca-vendas/' }, { name: 'E-commerce B2B', url: '/e-commerce-b2b/' }, { name: 'CRM', url: '/crm-de-vendas' }, { name: 'Mercos Pay', url: '/mercos-pay' }, { name: 'Videochamada', url: '/videochamada/' }]
    }, {
        title: 'Recursos',
        links: [{ name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' }, { name: 'Indicadores de vendas', url: '/recursos/indicadores-performance/' }, { name: 'Políticas comerciais', url: '/recursos/politica-comercial-vendas/' }, { name: 'Mercos IA', url: '/recursos/mercos-ia/' }]
    }, {
        title: 'Conteúdo',
        links: [{ name: 'Blog', url: 'https://blog.mercos.com/', external: true }, { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI', external: true }, { name: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                'E-commerce B2B: O',
                _react2.default.createElement('br', null),
                'que \xE9?'
            ), url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank', external: true }]
    }, {
        title: 'Transparência',
        links: [{ name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' }, { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' }, { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank', external: true }, { name: 'Relatório da igualdade salarial', url: '/relatorio-igualdade-salarial/' }]
    }, {
        title: 'Suporte',
        links: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', external: true }, {
            custom: true,
            content: _react2.default.createElement(
                'div',
                { className: 'support-info' },
                _react2.default.createElement(
                    'div',
                    { className: 'support-phone' },
                    '(47) 3481.8050'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'support-hours' },
                    'Atendimento de Segunda',
                    _react2.default.createElement('br', null),
                    'a Quinta das 9h \xE0s 17h.',
                    _react2.default.createElement('br', null),
                    'Sexta das 9h30 \xE0s 17h.'
                )
            )
        }]
    }], [{
        title: 'Segmentos',
        links: [{ name: 'Indústrias', url: '/industrias/' }, { name: 'Distribuidoras', url: '/distribuidoras/' }, { name: 'Representantes', url: '/representantes-comerciais/' }]
    }, {
        title: 'Planos e preços',
        links: [{ name: 'Indústrias e distribuidoras', url: '/planos-e-precos/industrias-e-distribuidoras/' }, { name: 'Representantes', url: '/planos-e-precos/representantes/' }]
    }, {
        title: 'Institucional',
        links: [{ name: 'Carreira', url: 'https://mercos.gupy.io/' }, { name: 'Sobre Nós', url: '/sobre/' }]
    }, {
        title: 'Integrações',
        links: [{ name: 'ERPs integrados', url: '/integracao-erp/' }, { name: 'Seja Parceiro', url: '/parceiros' }, { name: 'Documentação da API', url: 'https://docs.mercos.com/', external: true }]
    }, {
        title: 'Baixe o aplicativo',
        content: _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: 'app-buttons' },
                _react2.default.createElement(
                    'a',
                    { href: 'https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/app-store.png', alt: 'Baixar na App Store' })
                ),
                _react2.default.createElement(
                    'a',
                    { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                    _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/site/social/google-play.png', alt: 'Dispon\xEDvel no Google Play' })
                )
            ),
            _react2.default.createElement(
                'p',
                { className: 'app-downloads' },
                _react2.default.createElement(
                    'strong',
                    null,
                    '+100 mil'
                ),
                ' downloads'
            )
        )
    }]];

    var renderLink = function renderLink(link) {
        var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'footer-link';

        if (link.custom) return link.content;
        var target = link.target || (link.external ? '_blank' : null);

        return _react2.default.createElement(
            'a',
            {
                className: className,
                href: link.redirect ? null : link.url,
                onClick: link.redirect ? function () {
                    return (0, _Utm.redirectWithCookies)(link.url);
                } : null,
                target: target,
                rel: target === '_blank' ? 'noopener noreferrer' : null
            },
            link.name,
            link.external && _react2.default.createElement(
                'span',
                { className: 'material-icons site-footer__external-icon', 'aria-hidden': 'true' },
                'north_east'
            )
        );
    };

    var socialLinks = [{ name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' }, { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' }, { name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' }, { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' }, { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }];

    return _react2.default.createElement(
        'footer',
        { className: 'mercos-footer site-footer', 'aria-label': 'Rodap\xE9' },
        _react2.default.createElement(
            'div',
            { className: 'footer-content site-footer__inner' },
            _react2.default.createElement(
                'div',
                { className: 'site-footer__access' },
                _react2.default.createElement(
                    'p',
                    { className: 'site-footer__access-txt' },
                    'J\xE1 \xE9 cliente ou quer come\xE7ar?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'site-footer__access-actions' },
                    accessLinks.map(function (link, index) {
                        return _react2.default.createElement(
                            _react2.default.Fragment,
                            { key: link.url },
                            renderLink(link, 'site-footer__access-btn site-footer__access-btn--' + (index === 0 ? 'login' : 'signup'))
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'nav',
                { className: 'footer-main site-footer__nav', 'aria-label': 'Links do rodap\xE9' },
                footerRows.map(function (row, rowIndex) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'site-footer__nav-row', key: rowIndex },
                        row.map(function (section) {
                            return _react2.default.createElement(
                                'section',
                                { className: 'footer-section site-footer__section', key: section.title },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'section-title site-footer__col-title' },
                                    section.title
                                ),
                                section.content || _react2.default.createElement(
                                    'div',
                                    { className: 'section-links site-footer__links' },
                                    section.links.map(function (link, linkIndex) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'link-item', key: link.url || linkIndex },
                                            renderLink(link, 'footer-link site-footer__link')
                                        );
                                    })
                                )
                            );
                        })
                    );
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'footer-bottom site-footer__bar' },
            _react2.default.createElement(
                'div',
                { className: 'footer-container site-footer__bar-inner' },
                _react2.default.createElement(
                    'div',
                    { className: 'logo-container' },
                    _react2.default.createElement(
                        'a',
                        { href: '/', className: 'mercos-logo site-footer__bar-logo-link' },
                        _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: '/images/mercos-nuvini.svg', alt: 'Mercos - uma empresa nuvini' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'company-info site-footer__legal' },
                    _react2.default.createElement(
                        'div',
                        null,
                        '\xA9 ',
                        new Date().getFullYear(),
                        ' Simplest Software Ltda. Todos os direitos reservados.'
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        'CNPJ: 12.496.510/0001-80 \xB7 Av. Rolf Wiest, 277 (4\xBA andar) \xB7 Bom Retiro \u2014 Joinville/SC \xB7 CEP: 89223-005'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'social-links site-footer__social' },
                    socialLinks.map(function (social) {
                        return _react2.default.createElement(
                            'a',
                            {
                                key: social.name,
                                href: social.url,
                                target: '_blank',
                                rel: 'noopener noreferrer',
                                className: 'social-link site-footer__social-link',
                                'aria-label': social.name
                            },
                            _react2.default.createElement(_Picture2.default, { loading: 'lazy', src: social.icon, alt: 'Mercos no ' + social.name })
                        );
                    }),
                    _react2.default.createElement(
                        'span',
                        { className: 'feito-com-amor site-footer__made' },
                        'Feito com \uD83D\uDC9C'
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(530);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function Input(_ref) {
    var placeholder = _ref.placeholder,
        onChange = _ref.onChange,
        id = _ref.id,
        error = _ref.error,
        value = _ref.value,
        ariaLabel = _ref.ariaLabel,
        _ref$maxLength = _ref.maxLength,
        maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength,
        model = _ref.model,
        autoFocus = _ref.autoFocus,
        size = _ref.size,
        _ref$radius = _ref.radius,
        radius = _ref$radius === undefined ? 'all-rounded' : _ref$radius,
        _ref$type = _ref.type,
        type = _ref$type === undefined ? 'text' : _ref$type,
        name = _ref.name;
    return _react2.default.createElement('input', { className: (0, _classnames2.default)('input', error && 'error', model, size, radius),
        'aria-label': ariaLabel,
        autoFocus: autoFocus,
        id: id,
        maxLength: maxLength,
        onChange: onChange,
        placeholder: placeholder,
        type: type,
        value: value,
        name: name || id
    });
};

Input.propTypes = {
    id: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    ariaLabel: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    autoFocus: _propTypes2.default.bool,
    model: _propTypes2.default.oneOf(['outline', 'no-borders', 'secondary', 'success', 'alert', 'warning']),
    size: _propTypes2.default.string,
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded'])
};

exports.default = Input;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

__webpack_require__(548);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _siteNavData = __webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var renderItemTitle = function renderItemTitle(title) {
  if (typeof title === 'string') {
    return _react2.default.createElement(
      'h4',
      null,
      title
    );
  }
  return _react2.default.createElement(
    'h4',
    null,
    title
  );
};

var SiteNav = function SiteNav(_ref) {
  var _ref$hideOnScroll = _ref.hideOnScroll,
      hideOnScroll = _ref$hideOnScroll === undefined ? false : _ref$hideOnScroll,
      _ref$menuVisible = _ref.menuVisible,
      menuVisible = _ref$menuVisible === undefined ? true : _ref$menuVisible,
      _ref$pixelsToShowMenu = _ref.pixelsToShowMenuWhite,
      pixelsToShowMenuWhite = _ref$pixelsToShowMenu === undefined ? 50 : _ref$pixelsToShowMenu,
      _ref$transparentOnTop = _ref.transparentOnTop,
      transparentOnTop = _ref$transparentOnTop === undefined ? false : _ref$transparentOnTop,
      _ref$whiteBackground = _ref.whiteBackground,
      whiteBackground = _ref$whiteBackground === undefined ? false : _ref$whiteBackground,
      _ref$promoBarHeight = _ref.promoBarHeight,
      promoBarHeight = _ref$promoBarHeight === undefined ? 0 : _ref$promoBarHeight,
      _ref$loginOnly = _ref.loginOnly,
      loginOnly = _ref$loginOnly === undefined ? false : _ref$loginOnly,
      _ref$logoOnly = _ref.logoOnly,
      logoOnly = _ref$logoOnly === undefined ? false : _ref$logoOnly;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeMenu = _useState2[0],
      setActiveMenu = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isAtTop = _useState4[0],
      setIsAtTop = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mobileMenuOpen = _useState6[0],
      setMobileMenuOpen = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileOpenSections = _useState8[0],
      setMobileOpenSections = _useState8[1];

  var closeTimerRef = (0, _react.useRef)(null);
  var dropdownRefs = (0, _react.useRef)([]);

  var showTransparentTop = transparentOnTop && isAtTop && !whiteBackground && !mobileMenuOpen;

  var closeMobileMenu = (0, _react.useCallback)(function () {
    setMobileMenuOpen(false);
    setMobileOpenSections({});
  }, []);

  var toggleMobileMenu = function toggleMobileMenu() {
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      setMobileMenuOpen(true);
    }
  };

  var toggleMobileSection = function toggleMobileSection(index) {
    setMobileOpenSections(function (prev) {
      return _extends({}, prev, _defineProperty({}, index, !prev[index]));
    });
  };

  var closeAllDropdowns = function closeAllDropdowns() {
    return setActiveMenu(null);
  };

  var handleNavItemEnter = function handleNavItemEnter(index) {
    clearTimeout(closeTimerRef.current);
    setActiveMenu(index);

    var dd = dropdownRefs.current[index];
    if (!dd) return;

    dd.style.left = '';
    dd.style.right = '';

    requestAnimationFrame(function () {
      var rect = dd.getBoundingClientRect();
      var vw = window.innerWidth;
      if (rect.right > vw - 8) {
        var overflow = rect.right - (vw - 8);
        var currentLeft = parseFloat(window.getComputedStyle(dd).left) || 0;
        if (dd.style.right === '') {
          dd.style.left = currentLeft - overflow + 'px';
        }
      }
      if (rect.left < 8) {
        dd.style.left = '0px';
      }
    });
  };

  var handleNavItemLeave = function handleNavItemLeave(index) {
    closeTimerRef.current = setTimeout(function () {
      setActiveMenu(function (current) {
        return current === index ? null : current;
      });
    }, 100);
  };

  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsAtTop(scrollTop <= pixelsToShowMenuWhite);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pixelsToShowMenuWhite]);

  (0, _react.useEffect)(function () {
    document.body.classList.toggle('mobile-menu-is-open', mobileMenuOpen);
    if (!mobileMenuOpen) {
      return undefined;
    }

    var onKeyDown = function onKeyDown(event) {
      if (event.key === 'Escape') {
        closeMobileMenu();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return function () {
      document.body.classList.remove('mobile-menu-is-open');
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [mobileMenuOpen, closeMobileMenu]);

  (0, _react.useEffect)(function () {
    var onDocumentClick = function onDocumentClick(event) {
      if (!event.target.closest('.site-nav__item')) {
        closeAllDropdowns();
      }
    };

    var onEscape = function onEscape(event) {
      if (event.key === 'Escape') {
        closeAllDropdowns();
      }
    };

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onEscape);

    return function () {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onEscape);
      clearTimeout(closeTimerRef.current);
    };
  }, []);

  var navClassName = ['site-nav', hideOnScroll ? 'hide-on-scroll' : '', hideOnScroll && !menuVisible ? 'menu-hidden' : 'menu-visible', showTransparentTop ? 'at-top' : 'scrolled', promoBarHeight > 0 ? 'has-promo-bar' : '', mobileMenuOpen ? 'mobile-open' : '', logoOnly ? 'logo-only' : ''].filter(Boolean).join(' ');

  var menuItems = loginOnly ? [] : _siteNavData.siteNavData;

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement('link', { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' })
    ),
    _react2.default.createElement(
      'header',
      { className: navClassName, id: 'siteHeader' },
      _react2.default.createElement(
        'a',
        { href: '/', className: 'site-nav__logo', 'aria-label': 'Mercos' },
        _react2.default.createElement(_Picture2.default, {
          src: '/images/site/logo-mercos-colored.svg',
          alt: 'Mercos',
          className: 'site-nav__logo-img'
        })
      ),
      !loginOnly && !logoOnly && _react2.default.createElement(
        'nav',
        { className: 'site-nav__desktop', 'aria-label': 'Navega\xE7\xE3o principal' },
        _react2.default.createElement(
          'ul',
          { className: 'site-nav__menu' },
          menuItems.map(function (menuItem, idx) {
            return _react2.default.createElement(
              'li',
              {
                key: menuItem.label,
                className: 'site-nav__item' + (activeMenu === idx ? ' open' : ''),
                onMouseEnter: function onMouseEnter() {
                  return handleNavItemEnter(idx);
                },
                onMouseLeave: function onMouseLeave() {
                  return handleNavItemLeave(idx);
                }
              },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'site-nav__trigger',
                  'aria-haspopup': 'true',
                  'aria-expanded': activeMenu === idx
                },
                menuItem.label
              ),
              _react2.default.createElement(
                'div',
                {
                  ref: function ref(el) {
                    dropdownRefs.current[idx] = el;
                  },
                  className: 'site-nav__dropdown' + (menuItem.grid ? ' site-nav__dropdown--grid' : ''),
                  role: 'menu'
                },
                menuItem.items.map(function (item, subIdx) {
                  if (item.type === 'separator') {
                    return _react2.default.createElement(
                      'div',
                      { key: item.label + '-' + subIdx, className: 'site-nav__dd-label' },
                      item.label
                    );
                  }

                  return _react2.default.createElement(
                    'a',
                    {
                      key: item.link + '-' + subIdx,
                      href: item.link,
                      className: 'site-nav__dd-item',
                      role: 'menuitem',
                      target: item.target,
                      rel: item.target === '_blank' ? 'noopener noreferrer' : undefined
                    },
                    _react2.default.createElement(
                      'span',
                      { className: 'material-icons site-nav__dd-icon' },
                      item.icon
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'site-nav__dd-text' },
                      renderItemTitle(item.title),
                      item.description ? _react2.default.createElement(
                        'p',
                        null,
                        item.description
                      ) : null
                    )
                  );
                })
              )
            );
          })
        )
      ),
      !logoOnly && _react2.default.createElement(
        'div',
        { className: 'site-nav__actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__mobile-cta',
          onClick: function onClick() {
            return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
          }
        },
        'comece gr\xE1tis'
      ),
      !logoOnly && _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'site-nav__hamburger' + (mobileMenuOpen ? ' active' : ''),
          id: 'headerHamburger',
          'aria-label': mobileMenuOpen ? 'Fechar menu' : 'Abrir menu',
          'aria-expanded': mobileMenuOpen,
          'aria-controls': 'mobileNav',
          onClick: toggleMobileMenu
        },
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null),
        _react2.default.createElement('span', null)
      )
    ),
    !logoOnly && _react2.default.createElement(
      'nav',
      {
        className: 'site-nav__mobile' + (mobileMenuOpen ? ' active' : ''),
        id: 'mobileNav',
        'aria-label': 'Menu mobile',
        'aria-hidden': !mobileMenuOpen
      },
      menuItems.map(function (menuItem, idx) {
        return _react2.default.createElement(
          'div',
          {
            key: menuItem.label,
            className: 'site-nav__mob-section' + (mobileOpenSections[idx] ? ' open' : '')
          },
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: 'site-nav__mob-toggle',
              onClick: function onClick() {
                return toggleMobileSection(idx);
              }
            },
            menuItem.label,
            _react2.default.createElement(
              'span',
              { className: 'material-icons' },
              'expand_more'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'site-nav__mob-items' },
            _react2.default.createElement(
              'div',
              { className: 'site-nav__mob-items-inner' },
              menuItem.items.map(function (item, subIdx) {
                if (item.type === 'separator') {
                  return _react2.default.createElement(
                    'div',
                    { key: item.label + '-' + subIdx, className: 'site-nav__mob-label' },
                    item.label
                  );
                }

                return _react2.default.createElement(
                  'a',
                  {
                    key: item.link + '-' + subIdx,
                    href: item.link,
                    className: 'site-nav__mob-item',
                    target: item.target,
                    rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
                    onClick: closeMobileMenu
                  },
                  _react2.default.createElement(
                    'span',
                    { className: 'material-icons' },
                    item.icon
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    renderItemTitle(item.title),
                    item.description ? _react2.default.createElement(
                      'p',
                      null,
                      item.description
                    ) : null
                  )
                );
              })
            )
          )
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'site-nav__mob-actions' },
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-cta',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
            }
          },
          'comece gr\xE1tis'
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'site-nav__mob-actions-login',
            onClick: function onClick() {
              return (0, _Utm.redirectWithCookies)('https://app.mercos.com/login/');
            }
          },
          'Fazer login ',
          _react2.default.createElement(
            'span',
            { className: 'material-icons' },
            'chevron_right'
          )
        )
      )
    )
  );
};

exports.default = SiteNav;

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteNavData = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteNavData = exports.siteNavData = [{
  label: 'Soluções',
  items: [{
    title: 'Força de vendas',
    description: '+25 indicadores e +30 relatórios para gerenciar sua equipe',
    icon: 'bar_chart',
    link: '/forca-vendas/'
  }, {
    title: 'E-commerce B2B',
    description: 'Venda 24h por dia com a loja online de empresas para empresas',
    icon: 'shopping_cart',
    link: '/e-commerce-b2b'
  }, {
    type: 'separator',
    label: 'Outras Soluções'
  }, {
    title: 'CRM',
    description: 'Cuide da prospecção ao pós-venda dos clientes em um só lugar',
    icon: 'filter_alt',
    link: '/crm-de-vendas'
  }, {
    title: 'Mercos Pay',
    description: 'Receba pagamentos por pix, boleto e cartões de crédito',
    icon: 'credit_card',
    link: '/mercos-pay'
  }, {
    title: 'Videochamada',
    description: 'Venda por vídeo com experiência de visita presencial',
    icon: 'videocam',
    link: '/videochamada'
  }]
}, {
  label: 'Segmentos',
  items: [{
    title: 'Indústrias',
    description: 'Automatize vendas, conecte canais e escale seu negócio com inteligência',
    icon: 'factory',
    link: '/sistema-para-industria/'
  }, {
    title: 'Distribuidoras',
    description: 'Gerencie clientes e pedidos, vendas automatizadas e integração total',
    icon: 'home_work',
    link: '/sistema-distribuidora/'
  }, {
    title: 'Representantes',
    description: 'Crie e gerencie políticas comerciais para cada cliente e representada',
    icon: 'work',
    link: '/sistema-representante/'
  }]
}, {
  label: 'Planos e preços',
  items: [{
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Ind\xFAstrias e distribuidoras'
      )
    ),
    description: '',
    icon: 'factory',
    link: '/planos-e-precos/industrias-e-distribuidoras/'
  }, {
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Planos para ',
      _react2.default.createElement(
        'strong',
        null,
        'Representantes'
      )
    ),
    description: '',
    icon: 'work',
    link: '/planos-e-precos/representantes/'
  }]
}, {
  label: 'Integrações',
  items: [{
    title: 'ERPs integrados',
    description: '+250 ERPs parceiros integrados ao Força de vendas e E-commerce B2B',
    icon: 'device_hub',
    link: '/integracao-erp'
  }, {
    title: 'Seja Parceiro',
    description: 'Seja um Mpartner e leve seu negócio ao próximo nível',
    icon: 'people',
    link: '/parceiros'
  }]
}, {
  label: 'Recursos',
  grid: true,
  items: [{
    title: 'Aplicativo de vendas',
    description: 'Emita pedidos até sem internet e agilize a rotina do seu time comercial.',
    icon: 'smartphone',
    link: '/recursos/aplicativo-vendas-externas/'
  }, {
    title: 'Mercos IA',
    description: 'Inteligência Artificial na palma da sua mão',
    icon: 'auto_awesome',
    link: '/recursos/mercos-ia/'
  }, {
    title: 'Indicadores de vendas',
    description: 'Visualize a performance do seu comercial em tempo real e tome decisões mais rápidas.',
    icon: 'show_chart',
    link: '/recursos/indicadores-performance/'
  }, {
    title: 'Materiais ricos',
    description: 'Ebooks e guias para turbinar sua estratégia de vendas B2B.',
    icon: 'menu_book',
    link: '/materiais/'
  }, {
    title: 'Políticas comerciais',
    description: 'Aplique regras de preço, desconto e acréscimo sem erro – tudo de forma automática.',
    icon: 'flag',
    link: '/recursos/politica-comercial-vendas/'
  }, {
    title: 'Cases',
    description: 'Veja cases de sucesso e inspire melhores resultados para sua empresa.',
    icon: 'rocket_launch',
    link: 'https://mercos.com/cases/'
  }]
}];

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SiteNav = __webpack_require__(547);

var _SiteNav2 = _interopRequireDefault(_SiteNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SiteNav2.default;

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TESTIMONIALS = [{
    testimonial: "“Imagine a nossa felicidade em ganhar produtividade, se adaptar ao mercado e às tendências. Não tem jeito, quem não faz isso perde grandes oportunidades”",
    author: "Alexandre Santos",
    company: "Delícia Lanches"
}, {
    testimonial: "“Tínhamos o desafio de dobrar o faturamento em 12 meses e conseguimos atingir essa meta em apenas 10. O software da Mercos foi crucial para isto.”",
    author: "Rafael A. Krause",
    company: "Grupo Herbia"
}, {
    testimonial: "“Meu Foco é ajudar clientes a fazer negócios, para isso uso tanto o presencial quanto a tecnologia como aliados”",
    author: "Felipe Rodrigues",
    company: "IF Consultoria e Representação"
}, {
    testimonial: "“Essencial para qualquer representante que quer crescer. Toda minha equipe usa Mercos, melhoramos o atendimento e aumentarmos nosso volume de vendas.”",
    author: "Afonso Tonelli",
    company: "Musical Plus Representações"
}];
var TESTIMONIALS2 = [{
    testimonial: "“Desconheço software de vendas igual. Com Mercos elevamos o faturamento em mais 300% em menos de 3 anos.”",
    author: "Gustavo Ribeiro",
    company: "Impacttus Cosméticos"
}, {
    testimonial: "“Passamos a prospectar e vender, além do presencial, 24 horas e 7 dias da semana para os clientes! Nosso intuito era vender além do território que atingíamos com as vendas externas. E foi isso que começamos a fazer, em pouquíssimo tempo!”",
    author: "Alan Alves",
    company: "Almmati"
}, {
    testimonial: "“Minha melhor experiência com a Mercos, é a facilidade que ele me dá na rua. A dinâmica que eu tenho e o volume de informações que eu consigo, isso me facilita muito!”",
    author: "Cristiano Oliveira",
    company: "Representante Comercial Harman"
}];

var ModalTestimonials = function (_Component) {
    _inherits(ModalTestimonials, _Component);

    function ModalTestimonials() {
        _classCallCheck(this, ModalTestimonials);

        return _possibleConstructorReturn(this, (ModalTestimonials.__proto__ || Object.getPrototypeOf(ModalTestimonials)).apply(this, arguments));
    }

    _createClass(ModalTestimonials, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'modal-testimonials' },
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col' },
                    TESTIMONIALS.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'testimonials-col testimonials-col2' },
                    TESTIMONIALS2.map(function (testimonial) {
                        return _react2.default.createElement(
                            'div',
                            { className: 'modal-testimonial-box' },
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-text' },
                                testimonial.testimonial
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-name' },
                                testimonial.author
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'modal-testimonial-company' },
                                testimonial.company
                            )
                        );
                    })
                )
            );
        }
    }]);

    return ModalTestimonials;
}(_react.Component);

exports.default = ModalTestimonials;

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(574);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleTestimonialCard = function SingleTestimonialCard(_ref) {
  var text = _ref.text,
      stars = _ref.stars,
      personName = _ref.personName,
      companyName = _ref.companyName,
      personImage = _ref.personImage,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$testimonialEleme = _ref.testimonialElementType,
      testimonialElementType = _ref$testimonialEleme === undefined ? 'h4' : _ref$testimonialEleme;

  return _react2.default.createElement(
    'div',
    { className: 'single-testimonial-card ' + className },
    _react2.default.createElement(
      'div',
      { className: 'testimonial-content' },
      stars && _react2.default.createElement(
        'div',
        { className: 'testimonial-stars', 'aria-hidden': 'true' },
        stars
      ),
      _react2.default.createElement(testimonialElementType, { className: "testimonial-text" }, '"' + text + '"'),
      _react2.default.createElement(
        'div',
        { className: 'testimonial-author' },
        personImage && _react2.default.createElement(_Picture2.default, {
          src: personImage,
          alt: personName,
          className: 'author-image'
        }),
        _react2.default.createElement(
          'div',
          { className: 'author-info' },
          _react2.default.createElement(
            'div',
            { className: 'author-name' },
            personName
          ),
          companyName && _react2.default.createElement(
            'div',
            { className: 'author-company' },
            companyName
          )
        )
      )
    )
  );
};

exports.default = SingleTestimonialCard;

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

var _SingleTestimonialCard = __webpack_require__(573);

var _SingleTestimonialCard2 = _interopRequireDefault(_SingleTestimonialCard);

__webpack_require__(575);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwoColsV2 = function TwoColsV2(_ref) {
  var overTitle = _ref.overTitle,
      title = _ref.title,
      description = _ref.description,
      imageSrc = _ref.imageSrc,
      imageAlt = _ref.imageAlt,
      mobileSrc = _ref.mobileSrc,
      _ref$isReverse = _ref.isReverse,
      isReverse = _ref$isReverse === undefined ? false : _ref$isReverse,
      _ref$isImageFullWidth = _ref.isImageFullWidth,
      isImageFullWidth = _ref$isImageFullWidth === undefined ? false : _ref$isImageFullWidth,
      testimonial = _ref.testimonial,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      children = _ref.children,
      radialBg = _ref.radialBg,
      _ref$testimonialEleme = _ref.testimonialElementType,
      testimonialElementType = _ref$testimonialEleme === undefined ? 'h4' : _ref$testimonialEleme,
      _ref$descriptionEleme = _ref.descriptionElementType,
      descriptionElementType = _ref$descriptionEleme === undefined ? 'div' : _ref$descriptionEleme,
      _ref$separateHeadings = _ref.separateHeadings,
      separateHeadings = _ref$separateHeadings === undefined ? false : _ref$separateHeadings;

  var sectionClass = 'two-cols-v2 ' + (isReverse ? 'reverse' : '') + ' ' + (isImageFullWidth ? 'full-width-image' : '') + ' ' + className;
  var DescriptionElement = descriptionElementType;

  return _react2.default.createElement(
    'section',
    { className: sectionClass },
    radialBg && _react2.default.createElement('div', { className: 'radial-bg ' + radialBg + ' small' }),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'content-column' },
        separateHeadings ? _react2.default.createElement(
          _react.Fragment,
          null,
          overTitle && _react2.default.createElement(
            'p',
            { className: 'over-title' },
            overTitle
          ),
          title && _react2.default.createElement(
            'h3',
            { className: 'title' },
            title
          )
        ) : _react2.default.createElement(
          'h3',
          null,
          overTitle && _react2.default.createElement(
            'div',
            { className: 'over-title' },
            overTitle
          ),
          title && _react2.default.createElement(
            'div',
            { className: 'title' },
            title
          )
        ),
        description && _react2.default.createElement(
          DescriptionElement,
          { className: 'description' },
          description
        ),
        _react2.default.createElement(
          'div',
          { className: 'mobile-only' },
          _react2.default.createElement(_Picture2.default, {
            className: 'section-image',
            src: imageSrc,
            alt: imageAlt,
            mobileSrc: mobileSrc
          })
        ),
        children,
        testimonial && _react2.default.createElement(_SingleTestimonialCard2.default, _extends({}, testimonial, { testimonialElementType: testimonialElementType }))
      ),
      _react2.default.createElement(
        'div',
        { className: 'image-column desktop-only' },
        _react2.default.createElement(_Picture2.default, {
          className: 'section-image',
          src: imageSrc,
          alt: imageAlt,
          mobileSrc: mobileSrc
        })
      )
    )
  );
};

exports.default = TwoColsV2;

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _ClientLogosSlider = __webpack_require__(618);

var _ClientLogosSlider2 = _interopRequireDefault(_ClientLogosSlider);

__webpack_require__(605);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormHero = function FormHero(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        titleId = _ref.titleId,
        overtitle = _ref.overtitle,
        title = _ref.title,
        description = _ref.description,
        form = _ref.form;
    return _react2.default.createElement(
        'section',
        { className: 'hero form-hero-v1 form-hero-scoped ' + className, 'aria-labelledby': titleId },
        _react2.default.createElement(
            'div',
            { className: 'form-hero-v1__main' },
            _react2.default.createElement(
                'div',
                { className: 'form-hero-v1__content' },
                _react2.default.createElement(
                    'span',
                    { className: 'overtitle form-hero-v1__overtitle' },
                    overtitle
                ),
                _react2.default.createElement(
                    'h1',
                    { className: 'title form-hero-v1__title', id: titleId },
                    title
                ),
                _react2.default.createElement(
                    'h2',
                    { className: 'description form-hero-v1__description' },
                    description
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form-hero-v1__rating', 'aria-label': 'Avalia\xE7\xE3o: 4,8 de 5 estrelas' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-hero-v1__rating-line' },
                        _react2.default.createElement(
                            'span',
                            { className: 'form-hero-v1__stars', 'aria-hidden': 'true' },
                            '\u2605\u2605\u2605\u2605\u2605'
                        ),
                        _react2.default.createElement(
                            'span',
                            { 'aria-hidden': 'true' },
                            '4,8'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'form-hero-v1__rating-text' },
                        '12.255 Avalia\xE7\xF5es reais no ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Google Play'
                        ),
                        ', ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'App Store'
                        ),
                        ' e ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Google Meu Neg\xF3cio'
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'form-hero-v1__form' },
                form
            )
        ),
        _react2.default.createElement(_ClientLogosSlider2.default, { className: 'hero-form-logo-strip', hideHeader: true })
    );
};

exports.default = FormHero;

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(593);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClientLogosSlider = function ClientLogosSlider(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$hideHeader = _ref.hideHeader,
      hideHeader = _ref$hideHeader === undefined ? false : _ref$hideHeader;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldLoadLogos = _useState2[0],
      setShouldLoadLogos = _useState2[1];

  var logos = [{
    src: '/images/site/customers/alva-horizontal.png',
    alt: 'Alva',
    webp: '/images/site/customers/alva-horizontal.webp'
  }, {
    src: '/images/site/customers/anasol-horizontal.png',
    alt: 'Anasol',
    webp: '/images/site/customers/anasol-horizontal.webp'
  }, {
    src: '/images/site/customers/baggio-horizontal.png',
    alt: 'Baggio',
    webp: '/images/site/customers/baggio-horizontal.webp'
  }, {
    src: '/images/site/customers/berwanger-horizontal.png',
    alt: 'Berwanger',
    webp: '/images/site/customers/berwanger-horizontal.webp'
  }, {
    src: '/images/site/customers/beyoung-horizontal.png',
    alt: 'Beyoung',
    webp: '/images/site/customers/beyoung-horizontal.webp'
  }, {
    src: '/images/site/customers/buffalo-horizontal.png',
    alt: 'Buffalo',
    webp: '/images/site/customers/buffalo-horizontal.webp'
  }, {
    src: '/images/site/customers/cicero-horizontal.png',
    alt: 'Cicero',
    webp: '/images/site/customers/cicero-horizontal.webp'
  }, {
    src: '/images/site/customers/dobro-horizontal.png',
    alt: 'Dobro',
    webp: '/images/site/customers/dobro-horizontal.webp'
  }, {
    src: '/images/site/customers/gelopar-horizontal.png',
    alt: 'Gelopar',
    webp: '/images/site/customers/gelopar-horizontal.webp'
  }, {
    src: '/images/site/customers/herbia-horizontal.png',
    alt: 'Herbia',
    webp: '/images/site/customers/herbia-horizontal.webp'
  }, {
    src: '/images/site/customers/hey-mu-horizontal.png',
    alt: 'Hey Mu',
    webp: '/images/site/customers/hey-mu-horizontal.webp'
  }, {
    src: '/images/site/customers/hprime-horizontal.png',
    alt: 'HPrime',
    webp: '/images/site/customers/hprime-horizontal.webp'
  }, {
    src: '/images/site/customers/keune-horizontal.png',
    alt: 'Keune',
    webp: '/images/site/customers/keune-horizontal.webp'
  }, {
    src: '/images/site/customers/la-ganexa-horizontal.png',
    alt: 'La Ganexa',
    webp: '/images/site/customers/la-ganexa-horizontal.webp'
  }, {
    src: '/images/site/customers/labotrat-horizontal.png',
    alt: 'Labotrat',
    webp: '/images/site/customers/labotrat-horizontal.webp'
  }, {
    src: '/images/site/customers/maped-horizontal.png',
    alt: 'Maped',
    webp: '/images/site/customers/maped-horizontal.webp'
  }, {
    src: '/images/site/customers/mbled-horizontal.png',
    alt: 'MBled',
    webp: '/images/site/customers/mbled-horizontal.webp'
  }, {
    src: '/images/site/customers/mili-horizontal.png',
    alt: 'Mili',
    webp: '/images/site/customers/mili-horizontal.webp'
  }, {
    src: '/images/site/customers/mtx-horizontal.png',
    alt: 'MTX',
    webp: '/images/site/customers/mtx-horizontal.webp'
  }, {
    src: '/images/site/customers/oakberry-horizontal.png',
    alt: 'Oakberry',
    webp: '/images/site/customers/oakberry-horizontal.webp'
  }, {
    src: '/images/site/customers/tagima-horizontal.png',
    alt: 'Tagima',
    webp: '/images/site/customers/tagima-horizontal.webp'
  }];

  (0, _react.useEffect)(function () {
    var timeoutId = window.setTimeout(function () {
      return setShouldLoadLogos(true);
    }, 0);

    return function () {
      return window.clearTimeout(timeoutId);
    };
  }, []);

  var renderLogo = function renderLogo(logo, key) {
    return _react2.default.createElement(
      'div',
      { key: key, className: 'logo-item' },
      _react2.default.createElement(_Picture2.default, {
        src: logo.src,
        alt: logo.alt,
        mobileSrc: logo.webp,
        className: 'logo-image',
        loading: 'lazy',
        decoding: 'async'
      })
    );
  };

  return _react2.default.createElement(
    'div',
    { className: 'client-logos-slider-wrapper ' + className },
    !hideHeader && _react2.default.createElement(
      'p',
      { className: 'slider-header' },
      _react2.default.createElement(
        'b',
        null,
        '+ 9.000'
      ),
      ' empresas confiam na Mercos'
    ),
    _react2.default.createElement(
      'div',
      { className: 'client-logos-slider' },
      _react2.default.createElement(
        'div',
        { className: 'slider-track' },
        shouldLoadLogos && logos.map(function (logo, index) {
          return renderLogo(logo, 'logo-' + index);
        }),
        shouldLoadLogos && logos.map(function (logo, index) {
          return renderLogo(logo, 'logo-duplicate-' + index);
        })
      )
    )
  );
};

exports.default = ClientLogosSlider;

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Utm = __webpack_require__(532);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(620);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CallToActionSection = function CallToActionSection() {
    return _react2.default.createElement(
        'section',
        { className: 'call-to-action-section' },
        _react2.default.createElement('div', { className: 'radial-bg purple small' }),
        _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
                'div',
                { className: 'content-wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'left-content' },
                    _react2.default.createElement(
                        'p',
                        { className: 'title' },
                        'Conhe\xE7a nossos planos e teste gr\xE1tis'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'description' },
                        'Mais de 9.000 empresas confiam no Mercos para impulsionar a automa\xE7\xE3o da for\xE7a de vendas'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'buttons-wrapper' },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'new-form-btn new-form-btn-solid-green',
                                onClick: function onClick() {
                                    return (0, _Utm.redirectWithCookies)('https://app.mercos.com/cadastro/');
                                },
                                href: '#',
                                title: 'Fa\xE7a um teste gr\xE1tis'
                            },
                            'Fa\xE7a um teste gr\xE1tis'
                        ),
                        _react2.default.createElement(
                            'a',
                            { className: 'new-form-btn new-form-btn-bordered-green',
                                href: '/planos-e-precos/industrias-e-distribuidoras/'
                            },
                            'Ver planos e pre\xE7os'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'cta-bottom-text' },
                        _react2.default.createElement(
                            'span',
                            { className: 'desktop-text' },
                            'Teste gr\xE1tis por 7 dias | Sem cobran\xE7a ao terminar o per\xEDodo gr\xE1tis | Explore todos os recursos'
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'mobile-text' },
                            'Teste gr\xE1tis por 7 dias',
                            _react2.default.createElement('br', null),
                            'Sem cobran\xE7a ao terminar o per\xEDodo gr\xE1tis',
                            _react2.default.createElement('br', null),
                            'Explore todos os recursos'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'right-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'testimonial' },
                        _react2.default.createElement(
                            'div',
                            { className: 'author-avatar' },
                            _react2.default.createElement(_Picture2.default, {
                                src: '/images/site/depoimentos/rafael-vila-hr.png',
                                alt: 'Alessandro Gon\xE7alves',
                                className: 'avatar-image'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'testimonial-content' },
                            _react2.default.createElement(
                                'p',
                                { className: 'testimonial-text' },
                                '\u201CEm pouco tempo, o Mercos j\xE1 fez uma grande diferen\xE7a: conseguimos construir hist\xF3ricos de compras, entender o que os clientes levam ou n\xE3o e at\xE9 recuperar uma linha de produtos que n\xE3o estava saindo. Batemos nossas metas e seguimos crescendo.\u201D'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'testimonial-author' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'author-info' },
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'author-name' },
                                        'Rafael Vila'
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'author-position' },
                                        'Gerente comercial da Trato Vegano'
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    );
};

exports.default = CallToActionSection;

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__(531);

var _Picture2 = _interopRequireDefault(_Picture);

__webpack_require__(707);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndicatorsGrid = function IndicatorsGrid() {
  var gridRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      canScrollLeft = _useState2[0],
      setCanScrollLeft = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      canScrollRight = _useState4[0],
      setCanScrollRight = _useState4[1];

  var checkScrollPosition = function checkScrollPosition() {
    if (gridRef.current) {
      var _gridRef$current = gridRef.current,
          scrollLeft = _gridRef$current.scrollLeft,
          scrollWidth = _gridRef$current.scrollWidth,
          clientWidth = _gridRef$current.clientWidth;

      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  (0, _react.useEffect)(function () {
    var grid = gridRef.current;
    if (grid) {
      checkScrollPosition();
      grid.addEventListener('scroll', checkScrollPosition);
      return function () {
        return grid.removeEventListener('scroll', checkScrollPosition);
      };
    }
  }, []);

  var indicators = [{
    iconSrc: '/images/site/icons/donut.svg',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Curva ABC',
      _react2.default.createElement('br', null),
      'de Clientes'
    ),
    description: 'Classifique os clientes com base no valor faturado e defina prioridades na carteira dos vendedores'
  }, {
    iconSrc: '/images/site/icons/personplus.svg',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Positiva\xE7\xE3o',
      _react2.default.createElement('br', null),
      'de Clientes'
    ),
    description: 'Identifique quantos clientes fizeram pedidos e sua situação antes da positivação'
  }, {
    iconSrc: '/images/site/icons/reports.svg',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Relat\xF3rios',
      _react2.default.createElement('br', null),
      'de Vendas'
    ),
    description: 'Confira vendas e pedidos concluídos em um período e agrupe a visualização como preferir'
  }, {
    iconSrc: '/images/site/icons/finance.svg',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Evolu\xE7\xE3o',
      _react2.default.createElement('br', null),
      'de Vendas'
    ),
    description: 'Acompanhe quanto já foi vendido e tenha previsão do resultado do mês'
  }, {
    iconSrc: '/images/site/icons/personsearch.svg',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Acompanhamento de ',
      _react2.default.createElement('br', null),
      'clientes ativos e inativos'
    ),
    description: 'Transforme clientes inativos em oportunidades, evite inativações e mantenha as carteiras saudáveis'
  }, {
    iconSrc: '/images/site/icons/report.svg',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Ranking de metas',
      _react2.default.createElement('br', null),
      'e vendedores'
    ),
    description: 'Acompanhe as vendas em tempo real e incentive a equipe por meio de rankings estratégicos'
  }, {
    iconSrc: '/images/site/icons/tree.svg',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'For\xE7a de vendas integrado',
      _react2.default.createElement('br', null),
      'ao e-commerce B2B'
    ),
    description: _react2.default.createElement(
      _react.Fragment,
      null,
      'Venda online e acompanhe os dados de clientes e pedidos feitos pelo ',
      _react2.default.createElement(
        'nobr',
        null,
        'e-commerce B2B'
      )
    )
  }, {
    iconSrc: '/images/site/icons/sheet.svg',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Controle de',
      _react2.default.createElement('br', null),
      ' produtos e estoque'
    ),
    description: 'Confira os produtos mais vendidos por cliente e mantenha o estoque sempre atualizado'
  }, {
    iconSrc: '/images/site/icons/money.svg',
    title: _react2.default.createElement(
      _react.Fragment,
      null,
      'Comissionamento',
      _react2.default.createElement('br', null),
      'na palma da m\xE3o'
    ),
    description: 'Tenha as informações que você precisa sobre comissões a qualquer momento e incentive o time'
  }];

  return _react2.default.createElement(
    'section',
    { className: 'indicators-grid' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'header' },
        _react2.default.createElement(
          'h3',
          null,
          _react2.default.createElement(
            'p',
            { className: 'over-title' },
            '\uD83D\uDD25 Todos os seus resultados em um s\xF3 painel'
          ),
          _react2.default.createElement(
            'p',
            { className: 'title' },
            'S\xE3o mais de 25 indicadores e 30 relat\xF3rios',
            _react2.default.createElement('br', null),
            'para transformar dados em decis\xF5es'
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'grid-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'mobile-scroll-indicators' },
          _react2.default.createElement(
            'div',
            { className: 'scroll-arrow left ' + (canScrollLeft ? 'active' : '') },
            _react2.default.createElement(_Picture2.default, { src: '/images/site/arrow.svg', alt: 'Scroll left' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'scroll-arrow right ' + (canScrollRight ? 'active' : '') },
            _react2.default.createElement(_Picture2.default, { src: '/images/site/arrow.svg', alt: 'Scroll right' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'grid', ref: gridRef },
          indicators.map(function (indicator, index) {
            return _react2.default.createElement(
              'div',
              { key: index, className: 'indicator-card' },
              _react2.default.createElement(
                'div',
                { className: 'icon-container' },
                _react2.default.createElement(_Picture2.default, {
                  src: indicator.iconSrc,
                  alt: indicator.title,
                  className: 'icon'
                })
              ),
              _react2.default.createElement(
                'p',
                { className: 'card-title' },
                indicator.title
              ),
              _react2.default.createElement(
                'p',
                { className: 'card-description' },
                indicator.description
              )
            );
          })
        )
      )
    )
  );
};

exports.default = IndicatorsGrid;

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/site/recursos/SalesForcev3.jsx.cf897a0b.js